
const UnauthorisedDisplay = () => {

    return <div className="vertical-center">
        <p>You are not authorised access Variable Editor app!</p>
        <p>Please contact CDC support</p>
    </div>
}

export default UnauthorisedDisplay